module.exports = __webpack_public_path__ + "img/pexels-connor-danylenko-1414535.b5774d53.jpg";